// AnimalZakatCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import AnimalZakatTable from "./AnimalZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Animals_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Zakat Hewan Ternak - Hitung Zakat Hewan Ternak dengan Akurat dan Mudah ";
const DESCRIPTION =
  "Kalkulator Zakat Hewan Ternak adalah alat yang digunakan untuk menghitung jumlah zakat hewan ternak yang wajib dikeluarkan sesuai dengan ketentuan syariah dalam Islam. Kalkulator ini digunakan untuk menghitung jumlah uang yang harus dibayarkan sebagai zakat atas hewan ternak seperti unta, sapi, dan kambing";
const KEYWORDS =
  "kalkulator zakat hewan, hitung zakat hewan Anda, zakat hewan, cara menghitung zakat hewan, jumlah zakat hewan, aturan zakat hewan, menghitung zakat hewan dalam Islam, zakat hewan dalam syariah Islam, cara menghitung zakat hewan, kalkulator nisab zakat hewan, cara menghitung nisab zakat hewan, kalkulator zakat ternak, zakat ternak, menghitung zakat ternak, nisab zakat hewan dalam Islam";
const OG_URL = "https://do-calculate.com/calculator/id/animals-zakat/";
const apiEndpoint = `${SERVER_URL}/${Animals_Zakat_EndPoint}`;
function AnimalZakatCalculator() {
  const [camelCount, setCamelCount] = useState(0);
  const [cowCount, setCowCount] = useState(0);
  const [sheepCount, setSheepCount] = useState(0);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleCamelCountChange = (event) => {
    setCamelCount(event.target.value);
  };
  const handleCowCountChange = (event) => {
    setCowCount(event.target.value);
  };
  const handleSheepCountChange = (event) => {
    setSheepCount(event.target.value);
  };
  const calculateAnimalsZakat = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ camelCount, cowCount, sheepCount }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div >
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>Hitung Zakat Hewan Ternak</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Kalkulator Zakat Hewan Ternak adalah alat yang digunakan untuk menghitung jumlah zakat hewan ternak yang wajib dikeluarkan sesuai dengan ketentuan syariah dalam Islam. Kalkulator ini digunakan untuk menghitung jumlah uang yang harus dibayarkan sebagai zakat atas hewan ternak seperti unta, sapi, dan kambing
                <br />
                <hr />
              </div>
              <br />
            </div>
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Zakat Hewan (Ternak)
                </div>
                <hr />
                                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="cowCount" className="form-label ms-2">
                      Jumlah Sapi{" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="cowCount"
                    value={cowCount}
                    onChange={handleCowCountChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="sheepCount" className="form-label ms-2">
                      Jumlah Kambing{" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="sheepCount"
                    value={sheepCount}
                    onChange={handleSheepCountChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  />
                </div>
                <br/>                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateAnimalsZakat}
                       >
                    Hitung
                    </button>              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Terjadi kesalahan :</u>
                    </b>{" "}
                    Harap isi semua bidang dengan benar.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        Hasil:{" "}
                      </div>
                    </h4>
                    <hr />
                    <AnimalZakatTable result={result}></AnimalZakatTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Deskripsi Kalkulator Zakat Hewan (Ternak){" "}
              </div>
              <div className="info-section-body">
                <u>
                  <b> Kalkulator Zakat Hewan (Ternak) </b>{" "}
                </u>{" "}
                <br/>                Kalkulator menganalisis jumlah hewan sesuai dengan kriteria yang ditetapkan dalam syariah Islam, seperti batas minimum dan maksimum jumlah hewan, menghitung jumlah zakat yang wajib dikeluarkan, dan memberikan deskripsi untuk setiap kategori hewan serta jumlah yang harus dibayarkan sesuai dengan kategori tersebut.
                <br/>                Dengan menggunakan kalkulator, pengguna dapat memasukkan jumlah unta, sapi, dan kambing yang dimilikinya, kemudian jumlah zakat yang wajib dikeluarkan dihitung berdasarkan aturan dan standar syariah. Deskripsi terperinci disediakan untuk setiap kategori hewan dan jumlah yang harus dibayarkan, membantu pengguna memahami aturan dan persyaratan terkait zakat hewan ternak.
                <br/>                Dengan menggunakan Kalkulator Zakat Hewan Ternak, menjadi mudah dan nyaman bagi umat Muslim untuk menghitung dan menentukan jumlah zakat yang wajib dikeluarkan atas hewan ternak mereka dan memenuhi kewajiban syariah mereka.
                 <br/>
                <hr />
                <b>Tanggal revisi terakhir : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default AnimalZakatCalculator;